import { defineMessages, useIntl } from "react-intl";

import { OrderLabel } from "@/features/bookings/components/OrderLabel";
import type { ReservationStatus } from "@/features/bookings/types/types";

const orderStatusToDescriptionMapping = defineMessages({
  IN_PROGRESS: {
    defaultMessage: "Ticket issuing can take some time, please wait",
    description: "reservations.orderInProgressDescription",
  },
  REFUNDED: {
    defaultMessage: "Unfortunately we were unable to create a reservation",
    description: "reservations.orderRefundedDescription",
  },
});

type Props = {
  status: ReservationStatus;
};

export const OrderStatusSection = ({ status }: Props) => {
  const intl = useIntl();

  return (
    <section className="section-card mt-2 mb-4 flex w-full flex-col gap-4">
      <div className="flex w-full items-center justify-between">
        <span className="text-sm text-text-title">
          {intl.formatMessage({
            defaultMessage: "Order status",
            description: "reservations.orderStatus",
          })}
        </span>
        <OrderLabel status={status} />
      </div>
      {status === "REFUNDED" || status === "IN_PROGRESS" ? (
        <span className="text-xs text-text-tertiary">
          {intl.formatMessage(orderStatusToDescriptionMapping[status])}
        </span>
      ) : null}
    </section>
  );
};
